var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavHome = function SvgNavHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.689 7.062 11.343.415c-.714-.553-1.927-.553-2.64 0L.285 7.131c-.285.138-.356.484-.214.761.072.277.357.416.642.416h.714V16.2c0 1.038.784 1.8 1.854 1.8h4.566c.428 0 .713-.277.713-.692v-3.185c0-.485.785-.97 1.427-.97s1.498.485 1.498.97v3.185c0 .415.286.692.714.692h4.636c1.07 0 1.784-.692 1.784-1.8V8.308h.713c.286 0 .57-.208.642-.485.072-.277 0-.554-.285-.761Z",
    fill: "var(--primaryColor)"
  })));
};

export default SvgNavHome;